import isArray from "lodash/isArray";
import isString from "lodash/isString";
export const parseIfArrayValue = (fieldValue) => {
  if (isArray(fieldValue)) {
    return fieldValue;
  }
  if (isString(fieldValue)) {
    try {
      const parsedFieldValue = JSON.parse(fieldValue);
      if (isArray(parsedFieldValue)) {
        return parsedFieldValue;
      }
    } catch (ignored) {
    }
  }
  return void 0;
};
export const isArrayValue = (fieldValue) => !!parseIfArrayValue(fieldValue);
